import Cookie from 'services/Cookie';
import Http from 'services/Http';
import redirect from 'utils/redirect';
import { isReactNativeWebView } from 'utils/webAuthn';

const sanitize = string => `${string.replace(/\D/g, '')}`;

class Auth {
  listSessions(employeeId) {
    return Http.get(`/v1/employee/${employeeId}/tokens`);
  }

  deleteSessions(employeeId) {
    return Http.delete(`/v1/employee/${employeeId}/tokens`);
  }

  deleteSession(employeeId, sessionId) {
    return Http.delete(`/v1/employee/${employeeId}/token/${sessionId}`);
  }

  verify() {
    return Http.post('/v1/token/verify');
  }

  sendSMS(phone) {
    return Http.post('/v1/token/request', { phone: `+${sanitize(phone)}` });
  }

  sendEmail({ name, email, company }) {
    return Http.post('/v1/company/request', { userName: name, email, companyName: company });
  }

  async user(config) {
    const {
      data: { user, lastCompany },
    } = await Http.get('/v2/user/me', config);
    return { user, lastCompany };
  }

  async logout() {
    // The sign WebView must not DELETE the native session, including store builds that
    // still authenticate with the token cookie (OMM-792).
    if (isReactNativeWebView()) {
      return;
    }

    const token = Cookie.get('token');

    if (token) {
      await Http.delete(`/v1/token/${token.hash}`).catch(() => {});

      Cookie.removeAuthCookie('token');
      Cookie.removeAuthCookie('impersonate');
    }

    const hadSession = Boolean(token || Cookie.get('impersonate')?.hash);
    if (hadSession && window.location.pathname !== '/logout') {
      setTimeout(() => redirect('/logout'), 300);
    }
  }

  async acceptInvite(phone, token) {
    const response = await Http.post('/v1/user/confirm/invite', {
      phone,
      token,
    });
    return response;
  }
}

export default new Auth();
